

// Oh wouldn't it be nice if the product catalog had an API so this could be imported from there? 
// Whishfull thinking!

const equipmentCatalog = {
  ConferencingBars: [
    {
      modelName: 'Parlé ABC 2500a',
      partNumber: '911.1968.900',
      description: 'Conferencing audio bar with ALS port.',
    },
    {
      modelName: 'Parlé VBC 2500a',
      partNumber: '911.1967.900',
      hasCamera: true,
      description: 'Conferencing video bar with ALS port.',
    },
  ],

  Microphones: [
    // Ceiling mics
    {
      modelName: "Parlé TCM-XA",
      partNumber: "910.0499.900",
      isAmpUnit: true,
      description: "AVB Beamtracking, surface-mount ceiling microphone with PoE+ amplifier.",
    },
    {
      modelName: "Parlé TCM-X",
      partNumber: "911.0498.900",
      isBaseUnit: true,
      description: "AVB Beamtracking, surface-mount ceiling microphone.",
    },
    {
      modelName: "Parlé TCM-XEX",
      partNumber: "910.0500.900",
      isExpanderUnit: true,
      description: "Expansion AVB Beamtracking, surface-mount ceiling microphone.",
    },
    // pendant mics
    {
      modelName: "Parlé TCM-1A",
      partNumber: "911.0486.900",
      isPendant: true,
      isAmpUnit: true,
      description: "AVB Beamtracking pendant microphone with PoE+ amplifier.",
    },
    {
      modelName: "Parlé TCM-1 pendant",
      partNumber: "911.0485.900",
      isPendant: true,
      isBaseUnit: true,
      description: "AVB Beamtracking ceiling microphone.",
    },
    {
      modelName: "Parlé TCM-1EX",
      partNumber: "911.0487.900",
      isPendant: true,
      isExpanderUnit: true,
      description: "Pendant ceiling microphone",
    },
    // Tabletop mics
    {
      modelName: "Parlé TTM-X",
      partNumber: "910.0510.900",
      isTableTop: true,
      isBaseUnit: true,
      description: "AVB Beamtracking, tabletop microphone.",
    },
    {
      modelName: "Parlé TTM-XEX",
      partNumber: "910.0511.900",
      isTableTop: true,
      isExpanderUnit: true,
      description: "Expansion AVB Beamtracking, tabletop microphone.",
    },
  ],

  Speakers: [
    {
      modelName: 'Desono C-IC6 (units)',
      partNumber: '911.0925.900',
      description: 'In-ceiling, indoor, 6.5-inch, coaxial loudspeaker (priced individually, sold in pairs).'
    },
    {
      modelName: 'H10-G',
      partNumber: '911.1627.900',
      description: 'Compact industrial horn speaker'
    },
    {
      modelName: 'H20-G',
      partNumber: '911.1628.900',
      description: 'Weatherproof industrial horn speaker'
    },
    {
      modelName: 'H30LT-G',
      partNumber: '911.1629.900',
      description: 'Long throw horn speaker'
    },
    {
      modelName: 'MPLT62-G',
      partNumber: '911.1428.900',
      description: '2-way, long throw music projector horn speaker'
    },
    {
      modelName: 'R.25-94TZ',
      partNumber: '911.1236.900',
      description: 'Full-range, two-way coaxial 90°X40° horn speaker w/transformer'
    },
    {
      modelName: 'R.5-94TZ',
      partNumber: '911.1247.900',
      description: 'Full-range, two-way sound projector w/transformer'
    },
    {
      modelName: 'R.35-3896',
      partNumber: '910.0301.900',
      description: 'Full-range, triaxial three-way loudspeaker'
    },
    {
      modelName: 'R.15-3696',
      partNumber: '910.2264.900',
      description: 'Full-range, triaxial three-way loudspeaker'
    },
    {
      modelName: 'CCA-80',
      partNumber: '910.2265.900',
      description: 'Constant coverage, triaxial aisle loudspeaker'
    },
    {
      modelName: 'CCA-80D',
      partNumber: '950.2266.900',
      description: 'Dual, back-to-back, constant coverage, triaxial aisle loudspeaker'
    },
  ],

  Cameras: [
    {
      modelName: "Vidi 250",
      partNumber: "910.0130.900",
      description: "Wide angle 4K conferencing camera",
    },
  ],

  Processors: [
    // Tesira DSP ordered in ascending capacity
    {
      modelName: 'TesiraFORTÉ X 400',
      partNumber: '910.1803.900',
      description: 'Meeting Room DSP with 4 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 4
    },
    {
      modelName: 'TesiraFORTÉ X 800',
      partNumber: '911.0092.900',
      description: 'Meeting Room DSP with 8 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 8
    },
    {
      modelName: 'TesiraFORTÉ X 1600',
      partNumber: '911.0093.900',
      description: 'Meeting Room DSP with 16 channels of AEC.',
      productFamily: 'Tesira',
      capacity: 16
    },
    // Devio DSP ordered in ascending capacity
    {
      modelName: 'Devio SCX 400',
      partNumber: '910.1798.900',
      description: 'Conference room hub and audio DSP with 4 channels of AEC.',
      productFamily: 'Devio',
      capacity: 4
    },
    {
      modelName: 'Devio SCX 800',
      partNumber: '911.0090.900',
      description: 'Conference room hub and audio DSP with 8 channels of AEC.',
      productFamily: 'Devio',
      capacity: 8
    },
  ],

  Amplifiers: [
    {
      modelName: 'Tesira AMP-450BP',
      partNumber: '911.0014.900',
      description: 'Four-channel PoE+ speaker mounted amplifier.'
    }
  ],

  Switches: [
    {
      modelName: 'TesiraCONNECT TC-5',
      partNumber: '912.0039.900',
      description: '5-port connection device.'
    },
    {
      modelName: 'Biamp NMS-NG10GPX-AVB',
      partNumber: '911.1966.900',
      description: 'AVB-enabled Netgear 10-port 1G switch',
      ports: 8,
    },
    {
      modelName: 'Biamp NMS-NG26GPX-AVB',
      partNumber: '911.1976.900',
      description: 'AVB-enabled Netgear 26-port 1G switch',
      ports: 24,
    },
  ],

  Cables: [
    {
      modelName: 'EasyConnect C5E-3',
      partNumber: '909.1802.900',
      description: '3-foot (0.9-meter) CAT5e cable',
      length: "3'"
    },
    {
      modelName: 'EasyConnect C5E-10-P',
      partNumber: '909.1801.900',
      description: '10-foot (3-meter) plenum rated CAT5e cable',
      length: "10'"
    },
    {
      modelName: 'EasyConnect C5E-25-P',
      partNumber: '909.1800.900',
      description: '25-foot (7.6-meter) plenum rated CAT5e cable',
      length: "25'"
    },

  ],

  Accesories: [
    {
      modelName: 'BPAK',
      partNumber: '910.0912.900',
      description: 'Backpack adapter kit'
    }
  ],

  Bundles: [
    // Tesira X400 bundles
    {
      modelName: 'Biamp MRB-M-X400-C-CIC6',
      partNumber: '950.1804.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2
      }
    },
    {
      modelName: 'Biamp MRB-M-X400-T-CIC6',
      partNumber: '950.1806.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2
      }
    },
    {
      modelName: 'Biamp MRB-L-X400-C-CIC6',
      partNumber: '950.1805.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
    {
      modelName: 'Biamp MRB-L-X400-T-CIC6',
      partNumber: '950.1807.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Tesira',
      includes: {
        micModel: 'TTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
    // Devio SCX400 bundles
    {
      modelName: 'Biamp MRB-M-SCX400-C',
      partNumber: '950.1790.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Devio',
      includes: {
        micModel: 'TCM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2
      }
    },
    {
      modelName: 'Biamp MRB-M-SCX400-T',
      partNumber: '950.1792.900',
      description: 'Certified meeting room bundle for medium rooms (up to 11 participants).',
      productFamily: 'Devio',
      includes: {
        micModel: 'TTM-X',
        micQty: 1,
        spkrModel: 'C-IC6',
        spkrQty: 2
      }
    },
    {
      modelName: 'Biamp MRB-L-SCX400-C',
      partNumber: '950.1791.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Devio',
      includes: {
        micModel: 'TCM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
    {
      modelName: 'Biamp MRB-L-SCX400-T',
      partNumber: '950.1793.900',
      description: 'Certified meeting room bundle for large rooms (up to 18 participants).',
      productFamily: 'Devio',
      includes: {
        micModel: 'TTM-X',
        micQty: 2,
        spkrModel: 'C-IC6',
        spkrQty: 4
      }
    },
  ]


};

export default equipmentCatalog